import React from "react";
import memoizeOne from "memoize-one";
import S from "../../styles/components";
import PanelContext from "./PanelContext";
import Panel from "./Panel";

class PanelStack extends React.Component {
  state = {
    index: 0,
  };

  getMemoizedContext = memoizeOne((count = 0) => ({
    stackSize: count,
    nextPanel: this.nextPanel,
  }));

  handleClick = (event) => {
    this.setState({
      index: Number(event.target.value),
    });
  };

  render() {
    const { children, isHostedApp } = this.props;
    const { index } = this.state;

    // Removes null children to correct indexing when mapping through children
    const filteredChildren = children?.filter((child) => child);

    const titles = React.Children.toArray(filteredChildren)
      .filter((child) => child && child.props)
      .map((child) => child.props.title);

    const contextProps = this.getMemoizedContext(React.Children.count(titles));

    return (
      <PanelContext.Provider value={contextProps}>
        <S.PanelStack>
          <S.PanelStackHeader
            className={isHostedApp ? "panel-stack-media-tabs" : ""}
          >
            {titles.length > 1 &&
              titles.map((title, i) => (
                <S.PanelStackButton
                  key={`${title}_${i}`}
                  value={i}
                  onClick={this.handleClick}
                  active={i === index}
                >
                  {title}
                </S.PanelStackButton>
              ))}
          </S.PanelStackHeader>
          {React.Children.map(filteredChildren, (child, i) => {
            // If child is a player (only in HostedApp), display as usual.
            // This applies when having multiple mediaId tabs
            if (child?.props?.isPlayer) {
              return (
                <React.Fragment key={`${child?.props?.title}`}>
                  {child && i === index ? child : undefined}
                </React.Fragment>
              );
            }

            // Else, force the panelstack child to render but not display
            // Needed to grab the transcript from the DOM for export
            // This applies for panel children (ie. Transcript or Media tabs)
            return (
              <Panel
                key={`${child?.props?.title}`}
                style={{ display: `${child && i === index ? "flex" : "none"}` }}
              >
                {child}
              </Panel>
            );
          })}
        </S.PanelStack>
      </PanelContext.Provider>
    );
  }
}

export default PanelStack;
